<!-- Copyright (c) 2020-2021 ForgeRock. All rights reserved.

This software may be modified and distributed under the terms
of the MIT license. See the LICENSE file for details. -->
<template>
  <div>
    <BCard class="mb-5" data-testid="delete-panel">
      <h5 class="card-title">
        {{ $t('deletePanel.deleteType', { type: translatedItemType }) }}
      </h5>
      <p class="text-danger">
        {{ $t('common.cannotBeUndone') }}
      </p>
      <div style="display:flex;flex-direction:row;justify-content:flex-end">
        <BButton variant="danger" @click="showModal">
          {{ $t('deletePanel.deleteType', { type: translatedItemType }) }}
        </BButton>
      </div>
    </BCard>
    <FrDeleteModal :custom-message="customModalMessage" :is-deleting="isDeleting"
      :translated-item-type="translatedItemType" @delete-item="deleteItem" />
  </div>
</template>

<script>
import {
  BButton,
  BCard,
} from 'bootstrap-vue';
import axios from 'axios';
const ExcelJS = require('exceljs');
const FileSaver = require('file-saver');
import FrDeleteModal from '@forgerock/platform-shared/src/components/DeleteModal';


/**
 * Generic delete panel shown in a Bootstrap card. Clicking the delete button
 * shows a modal for confirmation and emits an event delete-item on delete.
 */
export default {
  name: 'DeletePanel',
  data() {
    return {
      isDisabled : false,
      isOpenidmAdmin: this.$store.state.UserStore.adminUser
    }
  },
  components: {
    BButton,
    BCard,
    FrDeleteModal,
    
  },
  props: {
    /**
     * Custom message to show in modal body
     */
    customModalMessage: {
      type: String,
      default: null,
    },
    /**
     * Variable to determine when to show spinner in button in modal
     */
    isDeleting: {
      type: Boolean,
      default: false,
    },
    /**
     * Type of item being deleted. Displayed in card header, button text, and modal title
     */
    translatedItemType: {
      type: String,
      default: '',
    },
    /**
     * This is for export optoin to be enabled or disabled.
     */
    resourceIsCompany: {
      type: Boolean,
      default: '',
    }
  },
  methods: {
    deleteItem() {
      /**
        * triggered when delete confirmation button is clicked in modal
        */
      this.$emit('delete-item');
    },
    showModal() {
      this.$root.$emit('bv::show::modal', 'deleteModal');
    },
    
  },
};
</script>
<style scoped>
.deleteButtonStyles {
  display: flex;
  flex-direction: row-reverse;
  justify-content: flex-start;
  gap: 10px;
}
</style>>
